import Vue from 'vue';

const getDefaultState = () => ({
  isLoadingSummaries: [],
  summaries: {},
});

export const state = () => getDefaultState();

export const actions = {
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
  async GET_TRAINING_SUMMARY({ commit }, { fromDate, toDate }) {
    try {
      commit('SET_LOADING_SUMMARY_START', { fromDate, toDate });

      const response = await this.$axios.$get('/api/training-summary/generate', {
        params: {
          from: fromDate,
          to: toDate,
        },
      });

      commit('SET_TRAINING_SUMMARY', { fromDate, toDate, data: response.data });
      commit('SET_LOADING_SUMMARY_END', { fromDate, toDate });
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

export const mutations = {
  CLEAR_DATA(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TRAINING_SUMMARY(state, { fromDate, toDate, data }) {
    const key = `${fromDate}-${toDate}`;
    if (state.summaries[key]) {
      Vue.set(state.summaries, key, data);
    } else {
      state.summaries[key] = data;
    }
  },
  SET_LOADING_SUMMARY_START(state, { fromDate, toDate }) {
    const key = `${fromDate}-${toDate}`;
    state.isLoadingSummaries.push(key);
  },
  SET_LOADING_SUMMARY_END(state, { fromDate, toDate }) {
    const key = `${fromDate}-${toDate}`;
    state.isLoadingSummaries = state.isLoadingSummaries.filter(item => item !== key);
  },
};
